import { render } from "./CircleGraph.vue?vue&type=template&id=71407c04&scoped=true"
import script from "./CircleGraph.vue?vue&type=script&lang=js"
export * from "./CircleGraph.vue?vue&type=script&lang=js"

import "./CircleGraph.vue?vue&type=style&index=0&id=71407c04&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71407c04"]])

export default __exports__